// API URL helper
// - Development / localhost: use REACT_APP_BACKEND_URL (e.g. http://localhost:8001)
// - Production browser (preview + any custom domain): always use same-origin
//   so that cookies, OAuth state session, and CORS all work correctly when
//   the app is served from multiple domains (life-sync-23.emergent.host,
//   lifeadminai.3stech.ai, lifeadminai.com.au …). The /api/* routes are
//   proxied to the backend by the ingress on every domain.
const envUrl = process.env.REACT_APP_BACKEND_URL || '';
const isBrowser = typeof window !== 'undefined';
const isLocalhost =
  isBrowser && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
const API_URL = isBrowser && !isLocalhost ? window.location.origin : envUrl;
export default API_URL;
